<template>
  <div id="app">
    <layout>
      <keep-alive include="Dashboard,QuickSignout">
        <router-view />
      </keep-alive>
    </layout>
    <StagingPopup />
    <update-popup />
  </div>
</template>
<script>
import UpdatePopup from "./components/UpdatePopup.vue";
import { mapState } from "vuex";
import Layout from "./components/common/Layout.vue";
import { UserTypesEnum } from "./modules/enums";
import StagingPopup from "./components/StagingPopup.vue";

export default {
  name: "IntelliPath-Pro",
  components: { UpdatePopup, Layout, StagingPopup },
  computed: {
    ...mapState({
      userDictionaryName: state => state.applicationSettings.userDictionaryName,
      currentLab: state => state.currentLab,
      currentUser: state => state.currentUser,

      updatePrompt: state => state.updatePrompt
    }),
    oldGeneratedDictionaryName() {
      const { firstName, lastName, userTypeId, labLocation } = this.currentUser;
      if (userTypeId !== UserTypesEnum.SuperUser) {
        return `${firstName}${lastName}${labLocation || ""}Dictionary`.replace(/\s+/i, "");
      }
      return `${firstName}${lastName}Dictionary`.replace(/\s+/i, "");
    },
    generatedDictionaryName() {
      if (this.userDictionaryName) {
        return this.userDictionaryName;
      }
      const { id } = this.currentUser;
      const newDictionaryName = `${id.replace(/\W/g, "")}Dictionary`;
      this.$store.commit("applicationSettings/setUserDictionaryName", newDictionaryName);
      return newDictionaryName;
    }
  },
  created() {
    const mediaQuery = window.matchMedia("(max-width: 767px)");
    mediaQuery.addEventListener("change", this.handleMediaResize);
    this.handleMediaResize(mediaQuery);
    window.addEventListener("keydown", this.handleKeydown);
    window.addEventListener("keyup", this.handleKeyup);
  },
  mounted() {
    if (this.currentUser?.id && this.currentUser?.recordLogRocket) {
      this.restartLogRocket();
    }
  },
  beforeDestroy() {
    const mediaQuery = window.matchMedia("(max-width: 767px)");
    mediaQuery.removeEventListener("change", this.handleMediaResize);
    window.removeEventListener("keydown", this.handleKeydown);
    window.removeEventListener("keyup", this.handleKeyup);
  },
  methods: {
    handleMediaResize(event) {
      this.$store.commit("setMobileView", event.matches);
    },
    handleKeydown({ key }) {
      key = key?.toLowerCase();
      if (["y", "n"].includes(key)) {
        const buttons = document.getElementsByClassName("dx-dialog-buttons");
        if (buttons?.length) {
          const buttonToClick = document.querySelector(
            `[aria-label="${key === "y" ? "Yes" : "No"}"]`
          );
          if (Object.keys(buttonToClick)) {
            buttonToClick.focus();
            setTimeout(() => buttonToClick.click(), 100);
          }
        }
      }
      if (key === "alt") {
        this.$store.commit("sessionDetails/setAltKeyDown", true);
      }
    },
    handleKeyup({ key }) {
      key = key?.toLowerCase();
      if (key === "alt") {
        this.$store.commit("sessionDetails/setAltKeyDown", false);
      }
    },
    async restartLogRocket() {
      this.$store.dispatch("sessionDetails/startRecordingLogRocket", true);
    }
  }
};
</script>
<style lang="scss">
#app {
  background: $background;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  position: relative;
}
@media screen and (min-width: 1024px) {
  #app {
    padding: 0 2.5%;
  }
  #nav {
    padding: 30px;
  }
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
